export const PREFIX = 'nl'
export const BREAKPOINTS = {
    mobileMaxWidth: 767, // anything above 767 will be treated as tablet
    desktopMinWidth: 1280,
    tabletMaxWidth: 1279, // anything above 1023 will be treated as desktop
    mobileLandscape: 667,
}
